import BankingForm from "components/Banking/banking-form"
import React from "react"
import * as url from "../../helpers/url_helper"
import {
    getMerchantBankingDetail,
    addNewMerchantBanking,
    clearMerchantBankingDetail,
    manageMerchantBanking,
    toggleMerchantBankingDefault,
    checkMerchantBankingStatus,
} from "store/merchants/actions"

// Stable selector functions to prevent rerenders
const bankingListSelector = (state) => state.merchants.merchantBanking || []
const bankingErrorSelector = (state) => state.merchants.bankingError
const bankingCreationSuccessSelector = (state) => state.merchants.bankingCreationSuccess

const MerchantBankingForm = (props) => {
    return (
        <BankingForm
            {...props}
            entityType="merchant"
            entityName="Merchant"
            // Banking actions
            getBankingListAction={getMerchantBankingDetail}
            addBankingAction={addNewMerchantBanking}
            manageBankingAction={manageMerchantBanking}
            toggleDefaultBankingAction={toggleMerchantBankingDefault}
            checkBankingStatusAction={checkMerchantBankingStatus}
            clearBankingListAction={clearMerchantBankingDetail}
            // Redux selectors
            bankingListSelector={bankingListSelector}
            bankingErrorSelector={bankingErrorSelector}
            bankingCreationSuccessSelector={bankingCreationSuccessSelector}
            // API configuration
            apiContextUri={url.MANAGE_MERCHANT_BANKING}
            toggleApiContextUri={url.TOGGLE_MERCHANT_BANKING_STATUS}
            toggleDefaultApiContextUri={url.TOGGLE_MERCHANT_BANKING_DEFAULT}
            checkStatusApiContextUri={url.CHECK_MERCHANT_BANKING_STATUS}
        />
    )
}

export default MerchantBankingForm